import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import Chart, { useChart } from './index';
import styles from '@stylesheet';
import { View, Text } from '@constants/Themed';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { Theme } from '@mui/material';
import React, {JSX} from 'react';
import RangePicker from '@components/Global/DateRangePicker/RangePicker';
import { MaterialIcons } from '@expo/vector-icons';

// ----------------------------------------------------------------------
interface DataSetChartProps {
  chart: {
    labels: string[];
    colors: string[];
    series: { name: string; data: number[]; fill: string }[];
    options: any;
  };
  subheader: string;
  chartTitle: string;
  chartType?: string;
  minHeight: number;
  dotLabel: string;
  title: string;
  rangeControls?: boolean,
  dateCallback: (date: {
    startDate: Date;
    endDate: Date;
  }) => void;
  defaultDates: { startDate: Date; endDate: Date };
  controls: JSX.Element | JSX.Element[];
  chartOnly?: boolean;

}
const DataSetChart: React.FC<DataSetChartProps> = ({ defaultDates, dateCallback, rangeControls, dotLabel, minHeight, controls, chartType, title, subheader, chart, chartOnly = false, ...other }) => {
  const { labels, colors, series, options } = chart;
  const theme = themeSelector();

  const chartOptions = useChart({
    colors,
    plotOptions: {
      bar: {
        columnWidth: '16%',
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shadeIntensity: 0.1,
        opacityFrom: 1,
        opacityTo: 0.5,
        stops: [0, 90, 100]
      }
    },
    labels,
    xaxis: {
      type: chartType || 'datetime',
    },
    tooltip: {
      shared: true,
      intersect: false,
      y: {
        formatter: (value) => {
          if (typeof value !== 'undefined') {
            return `${value?.toFixed?.(0)} ${dotLabel || 'visits'}`;
          }
          return value;
        },
      },
    },
    ...options,
  });

  return (
    <View style={[chartOnly ? {} : styles.defaultCardContainer, { marginTop: chartOnly ? 0 : 10 }]} {...other}>
      <Box sx={{ p: chartOnly ? 0 : 3, pb: chartOnly ? 0 : 1 }}>
        <Chart
          dir="ltr"
          xaxis={chartOptions.xaxis}
          type="line"
          series={series}
          options={chartOptions}
          width="100%"
          height={(controls ? (minHeight * 0.8) : minHeight) || 180}
        />
      </Box>
      {/* {((controls && React.Children.count(controls) > 0) || rangeControls) && (
        <View style={{ flex: 1, alignContent: "space-around", minHeight: 60, padding: 20, alignSelf: "stretch", flexDirection: "row" }}>
          {controls ? controls : null}
          {rangeControls && (
        <RangePicker dateCallback={dateCallback} startDate={defaultDates.startDate} endDate={defaultDates.endDate} />
          )}
        </View>
      )} */}
    </View>
  );
}

export default DataSetChart;
